// 文件处理工具函数
export const fileUtils = {
  // 格式化文件大小
  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  },

  // 验证文件类型
  validateFileType(file, allowedTypes) {
    const fileType = file.type
    const fileName = file.name
    const extension = fileName.split('.').pop().toLowerCase()
    
    // 检查 MIME 类型
    if (allowedTypes.mimeTypes && !allowedTypes.mimeTypes.includes(fileType)) {
      return false
    }
    
    // 检查文件扩展名
    if (allowedTypes.extensions && !allowedTypes.extensions.includes(extension)) {
      return false
    }
    
    return true
  },

  // 验证文件大小
  validateFileSize(file, maxSize) {
    return file.size <= maxSize
  },

  // 创建文件下载
  downloadFile(blob, filename) {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }
}